var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCommentResolved = function SvgCommentResolved(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#5CDBD3",
    fillOpacity: 0.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2 5H14.8C15.46 5 16 5.52595 16 6.16877V15.512C16 15.9459 15.4614 16.1632 15.1464 15.8564L13.8929 14.6355C13.7054 14.4528 13.451 14.3502 13.1858 14.3502H5.2C4.54 14.3502 4 13.8242 4 13.1814V6.16877C4 5.52595 4.54 5 5.2 5ZM13.1381 8.5434C13.3984 8.28982 13.3984 7.8787 13.1381 7.62512C12.8777 7.37155 12.4556 7.37155 12.1953 7.62512L9.66667 10.0879L8.13807 8.5991C7.87772 8.34553 7.45561 8.34553 7.19526 8.5991C6.93491 8.85268 6.93491 9.2638 7.19526 9.51738L9.19526 11.4653C9.45561 11.7189 9.87772 11.7189 10.1381 11.4653L13.1381 8.5434Z",
    fill: "#5CDBD3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCommentResolved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "comment-resolved.7747f927af3c0ef9f383ce1a9f4fc2b1.svg";